import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayoutCols3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M1.75 11C0.783501 11 -4.02866e-07 10.2165 -3.60619e-07 9.25L-7.64949e-08 2.75C-3.42479e-08 1.7835 0.783502 1 1.75 1L3 1L3 11L1.75 11Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12 9.25C12 10.2165 11.2165 11 10.25 11L9 11L9 1L10.25 1C11.2165 1 12 1.7835 12 2.75L12 9.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M4.5 11L4.5 1L7.5 1L7.5 11L4.5 11Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconGridLayoutCols3Fill12.js.map